import * as React from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'
  }
}))

const LinearLoading: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    <Box sx={{
      flexGrow: 1,
      width: '100%',
      marginTop: 2.5,
      marginBottom: 2.5
    }}>
      {isLoading && <BorderLinearProgress variant="indeterminate" />}
      {!isLoading && <div style={{ height: 5 }} />}
    </Box>
  )
}

export default LinearLoading
